<template>
  <div>
    <InputLabel
      v-if="labelValue"
      :required="required"
      :label="labelValue"
    />
    <div class="relative">
      <input
        :value="modelValue"
        :type="type"
        :name="name"
        :disabled="disabled"
        :placeholder="placeholder"
        :required="required"
        :autofocus="autofocus"
        class="h-16 px-6 rounded-full"
        :class="[{
          'border-red-600': hasError(),
          'border-gray-300': !hasError(),
          'pl-14': icon
        }, inputClass]"
        @input="inputListener(transformInputValue($event))"
      >
      <div
        v-if="icon"
        class="absolute top-0 left-0 flex items-center justify-start h-full pl-6 pointer-events-none"
      >
        <i
          class="mdi text-primary-100 text-lg"
          :class="`mdi-${icon}`"
        />
      </div>
    </div>
    <p
      v-if="hasError()"
      class="form-input-error mt-1"
    >
      {{ errorMessage() }}
    </p>
  </div>
</template>
<script>
import InputBase from "./InputBase";
import InputLabel from "../components/InputLabel.vue";

export default {
  name: "v-input",
  components: { InputLabel },
  extends: InputBase,
  props: {
    modelValue: {
      required: true,
      validator() {
        return true;
      }
    },
    type: {
      type: String,
      default: "text"
    },
    min: {
      default: undefined,
      type: Number
    },
    max: {
      default: undefined,
      type: Number
    },
    icon: {
      default: undefined,
      type: String
    }
  },
  methods: {
    transformInputValue(event) {
      if (event === null) {
        return null;
      }
      const value = _.get(event, "target.value", null);
      if (!_.isString(value)) {
        return null;
      }
      return _.trim(value);
    }
  }
};
</script>
